import React, { useState } from 'react';

// lists longer than this show their first items and a button for the rest
const SHORT_LIST = 6;

const Box = ({ on }) => (
    <span className={`hs-fp-box ${on ? 'on' : ''}`} aria-hidden='true'>
        {on && <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.4" strokeLinecap="round" strokeLinejoin="round"><path d="m5 12.5 4.5 4.5L19 7.5" /></svg>}
    </span>
);

// checkboxes; items are { key, label, on }. A ticked item stays in view while the list is short
export const CheckList = ({ items, onToggle, showAllLabel, showFewerLabel }) => {
    const [open, setOpen] = useState(false);
    const long = items.length > SHORT_LIST + 1;
    const shown = !long || open ? items : items.filter((item, i) => i < SHORT_LIST || item.on);

    return (
        <div className='hs-fp-list'>
            {shown.map(item => (
                <button key={item.key} type='button' role='checkbox' aria-checked={item.on}
                    className={`hs-fp-check ${item.on ? 'on' : ''}`} onClick={() => onToggle(item.key)}>
                    <Box on={item.on} />
                    <span>{item.label}</span>
                </button>
            ))}
            {long &&
                <button type='button' className='hs-fp-more' onClick={() => setOpen(!open)}>
                    {open ? showFewerLabel : showAllLabel(items.length)}
                </button>}
        </div>
    );
};

export const PanelSection = ({ title, children }) => (
    <section className='hs-fp-section'>
        <h3>{title}</h3>
        {children}
    </section>
);

// the filters beside the results, on wider screens
export const FilterPanel = ({ title, resetLabel, onReset, canReset, top, children }) => (
    <aside className='hs-fp' style={{ top, maxHeight: `calc(100vh - ${top + 16}px)` }}>
        <div className='hs-fp-head'>
            <h2>{title}</h2>
            {canReset && <button type='button' onClick={onReset}>{resetLabel}</button>}
        </div>
        {children}
    </aside>
);
